export default "__VITE_ASSET__CvNr8mt3__"